<ui-modal [modalTitle]="productId ? 'Manage Warehouse Product SKU' : 'Manage Warehouse SKU'" [footer]="step !== 'choose'" size="lg" [scrollable]="true">

	<div class="d-flex align-items-center mb-3">
		<ng-container *ngIf="details">
			<div class="product-image mr-3 flex-shrink-0" [style.backgroundImage]="((details?.image_url || 'assets/img/image-placeholder.png') ? 'url(\'' + (details?.image_url || 'assets/img/image-placeholder.png') + '\')' : '') | safeStyle"></div>
			<div class="flex-weight-1" style="min-width: 0;">
				<div *ngIf="details.short_description" class="text-bold text-lines lines-1" uiEllipsisTooltip>{{ details.short_description }}</div>
				<div *ngIf="details.manufacturer_name || details.model" class="text-secondary text-small text-lines lines-1" uiEllipsisTooltip>
					{{ details.manufacturer_name }}{{ details.manufacturer_name && details.model ? ' / ' : '' }}{{ details.model }}
				</div>
				<div *ngIf="details.sku || details.manufacturer_sku" class="text-secondary text-tiny">{{ details.sku || details.manufacturer_sku }}</div>
			</div>
		</ng-container>

		<div *ngIf="sku" [ngClass]="{ 'ml-3 pl-3 border-left text-right flex-shrink-0' : productId }">
			<div class="text-uppercase text-tiny text-secondary">Warehouse SKU</div>
			<div class="text-info text-bold">{{ sku }}</div>
		</div>
	</div>

	<div *ngIf="step === 'choose'" class="alert alert-warning mb-3">
		<i class="wq wq-warning text-large mr-2"></i>
		Any change made here will impact all warehouses and locations where this SKU or product is currently stocked or has been stocked previously.
	</div>

	<div *ngIf="step === 'choose'" class="row">
		<div [ngClass]="productId ? 'col-4' : 'col-6'">
			<div class="border rounded p-4 h-100 selectable hoverable position-relative text-center" (click)="choose('rename')">
				<span class="badge bg-secondary-15 text-bold text-dark position-absolute" style="top: 0.75rem; right: 0.75rem;">LOW</span>
				<div class="d-inline-flex align-items-center justify-content-center bg-light rounded-circle mb-3" style="width: 4rem; height: 4rem;">
					<i class="wq wq-edit text-secondary" style="font-size: 1.5rem;"></i>
				</div>
				<div class="text-bold text-large mb-2">Rename</div>
				<div class="text-secondary text-small">Change the SKU code. Stock, history, and assignments stay intact.</div>
			</div>
		</div>
		<div [ngClass]="productId ? 'col-4' : 'col-6'">
			<div class="border rounded p-4 h-100 selectable hoverable position-relative text-center" (click)="choose('merge')">
				<span class="badge bg-warning-15 text-bold text-warning position-absolute" style="top: 0.75rem; right: 0.75rem;">MEDIUM &mdash; IRREVERSIBLE</span>
				<div class="d-inline-flex align-items-center justify-content-center bg-light rounded-circle mb-3" style="width: 4rem; height: 4rem;">
					<i class="wq wq-combine text-secondary" style="font-size: 1.5rem;"></i>
				</div>
				<div class="text-bold text-large mb-2">Merge</div>
				<div class="text-secondary text-small">Combine this SKU into another. Stock, POs, reservations, and history transfer to the target.</div>
			</div>
		</div>
		<div *ngIf="productId" class="col-4">
			<div class="border rounded p-4 h-100 selectable hoverable position-relative text-center" (click)="choose('separate')">
				<span class="badge bg-warning-15 text-bold text-warning position-absolute" style="top: 0.75rem; right: 0.75rem;">MEDIUM &mdash; IRREVERSIBLE</span>
				<div class="d-inline-flex align-items-center justify-content-center bg-light rounded-circle mb-3" style="width: 4rem; height: 4rem;">
					<i class="wq wq-split text-secondary" style="font-size: 1.5rem;"></i>
				</div>
				<div class="text-bold text-large mb-2">Separate Allocated Stock</div>
				<div class="text-secondary text-small">Move this product's allocated stock off this SKU onto a new SKU.</div>
			</div>
		</div>
	</div>

	<ng-container *ngIf="step === 'rename'">
		<div class="text-uppercase text-small text-bold text-secondary mb-2">Current SKU</div>
		<input type="text" class="form-control mb-3 w-50" [value]="sku" disabled>

		<div class="text-uppercase text-small text-bold text-secondary mb-2">New SKU</div>
		<input type="text" class="form-control w-50"
			[(ngModel)]="newSku" (ngModelChange)="onNewSkuInput()" autocomplete="chrome-off" spellcheck="false" appAutoFocus
			[ngClass]="{ 'is-invalid': newSku && !skuChecking && skuAvailable === false, 'is-valid': newSku && !skuChecking && skuAvailable === true && newSku.trim() !== sku }">

		<div class="text-small mt-1">
			<span *ngIf="newSku && newSku.trim() === sku" class="text-secondary">The new SKU must differ from the current one.</span>
			<span *ngIf="newSku && newSku.trim() !== sku && skuChecking" class="text-secondary">Checking availability…</span>
			<span *ngIf="newSku && newSku.trim() !== sku && !skuChecking && skuAvailable === true" class="text-success"><i class="wq wq-check mr-1"></i>Available organisation-wide.</span>
			<span *ngIf="newSku && newSku.trim() !== sku && !skuChecking && skuAvailable === false" class="text-danger"><i class="wq wq-close mr-1"></i>This SKU is already in use.</span>
			<span *ngIf="!newSku" class="text-secondary">Must be unique across the organisation.</span>
		</div>
	</ng-container>

	<ng-container *ngIf="step === 'merge'">
		<div class="text-uppercase text-small text-bold text-secondary mb-2">Merge into…</div>

		<div class="input-group">
			<div class="input-group-prepend">
				<span class="input-group-text"><i class="wq wq-search"></i></span>
			</div>
			<input *ngIf="!selectedTarget" type="text" class="form-control" placeholder="Search Warehouse SKUs"
				[(ngModel)]="mergeSearch" (ngModelChange)="onMergeSearchInput()" autocomplete="chrome-off" spellcheck="false" appAutoFocus>
			<input *ngIf="selectedTarget" type="text" class="form-control text-info text-bold"
				[value]="selectedTarget.warehouse_sku + (selectedTarget.short_description ? ' — ' + selectedTarget.short_description : '')" readonly>
			<div class="input-group-append" *ngIf="selectedTarget || mergeSearch">
				<button type="button" class="btn btn-outline-secondary border" (click)="clearTarget()" [disabled]="disabled" ngbTooltip="Clear">
					<i class="wq wq-close"></i>
				</button>
			</div>
		</div>

		<div *ngIf="!selectedTarget && mergeSearch.trim()" class="mt-2" style="max-height: 22rem; overflow-y: auto; overflow-x: hidden;">
			<div *ngIf="mergeSearching" class="text-secondary text-small py-2">Searching…</div>

			<ng-container *ngIf="!mergeSearching">
				<div *ngFor="let sku of mergeResults" class="border rounded p-2 mb-2 selectable hoverable" (click)="selectTarget(sku)">
					<div class="d-flex align-items-center p-1">
						<span class="text-info text-bold mr-2 nowrap flex-weight-1">{{ sku.warehouse_sku }}</span>
						<span *ngIf="sku.warehouse_count" class="text-secondary text-small nowrap mr-2" [ngbTooltip]="sku.warehouse_name">
							<i class="wq wq-location mr-1"></i>{{ sku.warehouse_count }} location{{ sku.warehouse_count !== 1 ? 's' : '' }}
						</span>
						<span class="badge badge-secondary text-no-transform mr-2 nowrap">{{ sku.product_count }} product{{ sku.product_count !== 1 ? 's' : '' }}</span>
						<i class="wq wq-chevron-right text-secondary"></i>
					</div>

					<div *ngIf="sku.products?.length" class="d-flex mt-1" style="overflow-x: auto;">
						<div *ngFor="let p of sku.products" class="p-1" style="flex: 0 0 8rem;">
							<div class="border rounded p-2 text-center h-100">
								<div class="product-image mx-auto mb-2" [style.backgroundImage]="(p.image_url ? 'url(\'' + p.image_url + '\')' : '') | safeStyle"></div>
								<div class="text-bold text-small text-lines lines-2">{{ p.short_description }}</div>
								<div *ngIf="p.manufacturer_name" class="text-secondary text-tiny">{{ p.manufacturer_name }}</div>
							</div>
						</div>
					</div>
				</div>

				<div *ngIf="!mergeResults.length" class="text-secondary text-small py-2">No Warehouse SKUs found.</div>
			</ng-container>
		</div>

		<div *ngIf="selectedTarget && (sourceStats || targetStats || loadingSourceStats || loadingTargetStats)" class="mt-3 border rounded">
			<table class="table mb-0">
				<thead>
					<tr class="bg-light">
						<th></th>
						<th class="text-center text-uppercase text-small text-secondary">This SKU (source)</th>
						<th class="text-center text-uppercase text-small text-info">Target SKU</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td class="text-secondary">Code</td>
						<td class="text-center">{{ sourceStats?.code || sku || '—' }}</td>
						<td class="text-center text-info text-bold">{{ targetStats?.code || selectedTarget?.warehouse_sku || '—' }}</td>
					</tr>
					<tr>
						<td class="text-secondary">Assigned products</td>
						<td class="text-center">{{ sourceStats?.assigned_products }}</td>
						<td class="text-center">{{ targetStats?.assigned_products }}</td>
					</tr>
					<tr>
						<td class="text-secondary">Total stock</td>
						<td class="text-center">{{ sourceStats?.total_stock | decimal:0:4:true}}</td>
						<td class="text-center">{{ targetStats?.total_stock | decimal:0:4:true }}</td>
					</tr>
					<tr>
						<td class="text-secondary">Active reservations</td>
						<td class="text-center">{{ sourceStats?.active_reservations | decimal:0:4:true}}</td>
						<td class="text-center">{{ targetStats?.active_reservations | decimal:0:4:true }}</td>
					</tr>
					<tr>
						<td class="text-secondary">Open POs</td>
						<td class="text-center">{{ sourceStats?.open_pos }}</td>
						<td class="text-center">{{ targetStats?.open_pos }}</td>
					</tr>
					<tr>
						<td class="text-secondary">Serialised</td>
						<td class="text-center">{{ sourceStats?.is_serialised ? 'Yes' : 'No' }}</td>
						<td class="text-center">{{ targetStats?.is_serialised ? 'Yes' : 'No' }}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div *ngIf="selectedTarget" class="alert text-secondary bg-light mt-3">
			<i class="wq wq-combine mr-2"></i>
			After merging, <b>{{ sourceStats?.total_stock | decimal:0:4:true }}</b> units of stock,
			<b>{{ sourceStats?.active_reservations ?? 0 }}</b> reservation{{ sourceStats?.active_reservations === 1 ? '' : 's' }} and
			<b>{{ sourceStats?.open_pos ?? 0 }}</b> PO{{ sourceStats?.open_pos === 1 ? '' : 's' }}
			will move under <b>{{ selectedTarget.warehouse_sku }}</b> across all locations/warehouses. The <b>{{ sku }}</b> code will be permanently deleted.
		</div>
	</ng-container>

	<ng-container *ngIf="step === 'separate'">
		<div class="alert text-secondary bg-light">Splits this product onto a new SKU. Only allocations raised for this product move, along with their stock and any free stock you choose. Other mapped products and their allocations stay on this SKU</div>
		<div class="text-uppercase text-small text-bold text-secondary mb-2">New SKU</div>
		<input type="text" class="form-control w-50"
			[(ngModel)]="newSku" (ngModelChange)="onNewSkuInput()" autocomplete="chrome-off" spellcheck="false" appAutoFocus
			[ngClass]="{ 'is-invalid': newSku && !skuChecking && skuAvailable === false, 'is-valid': newSku && !skuChecking && skuAvailable === true && newSku.trim() !== sku }">

		<div class="text-small mt-1">
			<span *ngIf="newSku && newSku.trim() === sku" class="text-secondary">The new SKU must differ from the current one.</span>
			<span *ngIf="newSku && newSku.trim() !== sku && skuChecking" class="text-secondary">Checking availability…</span>
			<span *ngIf="newSku && newSku.trim() !== sku && !skuChecking && skuAvailable === true" class="text-success"><i class="wq wq-check mr-1"></i>Available organisation-wide.</span>
			<span *ngIf="newSku && newSku.trim() !== sku && !skuChecking && skuAvailable === false" class="text-danger"><i class="wq wq-close mr-1"></i>This SKU is already in use.</span>
			<span *ngIf="!newSku" class="text-secondary">Must be unique across the organisation.</span>
		</div>

		<div *ngIf="loadingSeparationInfo" class="text-secondary text-small py-3">Loading…</div>

		<ng-container *ngIf="separationInfo">
			<div class="text-uppercase text-small text-bold text-secondary mt-4 mb-2">Allocations moving to the new SKU</div>
			<div *ngIf="!separationInfo.allocations?.length" class="text-secondary text-small">This product has no allocated stock on this SKU.</div>
			<table *ngIf="separationInfo.allocations?.length" class="table table mb-0 border rounded">
				<thead>
					<tr class="bg-light">
						<th>Request</th>
						<th>Project</th>
						<th>Location</th>
						<th class="text-right">Allocated Qty</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let a of separationInfo.allocations">
						<td>{{ a.request_no }}</td>
						<td>{{ a.project_description || a.request_description || '—' }}</td>
						<td>{{ a.warehouse_name }}</td>
						<td class="text-right">{{ a.quantity | decimal:0:4:true }}</td>
					</tr>
				</tbody>
			</table>

			<div class="text-uppercase text-small text-bold text-secondary mt-4 mb-2">Also move free stock <span class="text-no-transform">(optional)</span></div>
			<div *ngIf="!separationInfo.warehouses?.length" class="text-secondary text-small">No free stock available to move.</div>

			<div *ngFor="let wh of separationInfo.warehouses" class="border rounded mb-2">
				<div class="d-flex align-items-center bg-light px-3 py-2">
					<i class="wq wq-warehouse text-secondary mr-2"></i>
					<span class="text-bold mr-2">{{ wh.name }}</span>
					<span *ngIf="warehouseTypeLabel(wh.type)" class="badge badge-secondary text-no-transform mr-2">{{ warehouseTypeLabel(wh.type) }}</span>
					<div class="flex-weight-1"></div>
					<span *ngIf="wh.in_transfer_all > 0" class="text-warning text-small mr-3" ngbTooltip="Committed to open free-stock transfers (including drafts) — not pickable">
						<i class="wq wq-truck mr-1"></i>In open transfers: <b>{{ wh.in_transfer_all | decimal:0:4:true }}</b>
					</span>
					<span class="text-secondary text-small">Pickable free stock: <b>{{ wh.free_stock | decimal:0:4:true }}</b></span>
					<button type="button" class="btn btn-outline-success btn px-2 ml-3" (click)="pickAllFree(wh)" [disabled]="disabled">
						<i class="wq wq-add mr-1"></i>Add All
					</button>
				</div>
				<table class="table table vam mb-0">
					<tbody>
						<tr *ngFor="let loc of wh.locations">
							<td class="pl-3">
								{{ loc.location_name }}
								<span *ngIf="loc.is_staging" class="badge badge-secondary text-no-transform ml-2">Staging</span>
							</td>
							<td class="text-right text-secondary">
								<span *ngIf="loc.in_transfer_qty > 0" class="text-warning mr-3" ngbTooltip="Locked by open free-stock transfers — cannot be moved">
									<i class="wq wq-truck mr-1"></i>{{ loc.in_transfer_qty | decimal:0:4:true }} locked
								</span>
								{{ loc.quantity | decimal:0:4:true }} in stock
							</td>
							<td class="shrink pr-3">
								<div class="d-flex align-items-center justify-content-end">
									<button type="button" class="btn btn-outline-primary btn px-1 border-0 mr-1"
										[disabled]="pickQty(loc) < 0.0001 || disabled || loc.is_staging" (click)="decrementPick(wh, loc)"><i class="wq wq-remove"></i></button>
									<input type="text" class="form-control form-control text-center w-4r" placeholder="0"
										[(ngModel)]="loc.move_quantity" [ngModelOptions]="{ standalone: true }" (change)="onPickChange(wh, loc)"
										[disabled]="disabled || !wh.free_stock || loc.is_staging" [ngbTooltip]="loc.is_staging ? 'Cannot move staging location free stock' : null">
									<button type="button" class="btn btn-outline-primary btn px-1 border-0 ml-1"
										[disabled]="pickQty(loc) >= pickLimit(wh, loc) || disabled || loc.is_staging" (click)="incrementPick(wh, loc)"><i class="wq wq-add"></i></button>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="alert text-secondary bg-light mt-3">
				<i class="wq wq-split mr-2"></i>
				<b>{{ details?.short_description || 'This product' }}</b> will be remapped to the new SKU along with
				<b>{{ separateAllocatedTotal() | decimal:0:4:true }}</b> allocated unit{{ separateAllocatedTotal() === 1 ? '' : 's' }}<ng-container *ngIf="separateFreeTotal()">,
				<b>{{ separateFreeTotal() | decimal:0:4:true }}</b> free unit{{ separateFreeTotal() === 1 ? '' : 's' }}</ng-container><ng-container *ngIf="separationInfo.linked_serials">
				and <b>{{ separationInfo.linked_serials }}</b> linked serial{{ separationInfo.linked_serials === 1 ? '' : 's' }}</ng-container>.
				<b>{{ sku }}</b> keeps its history and any other mapped products.
			</div>
		</ng-container>
	</ng-container>

	<button *ngIf="step !== 'choose'" type="button" class="btn btn-secondary" (click)="back()" [disabled]="disabled" ui-modal-footer>
		<i class="wq wq-chevron-left mr-1"></i>Back
	</button>
	<div *ngIf="step !== 'choose'" class="flex-weight-1" ui-modal-footer></div>
	<button *ngIf="step === 'rename'" type="button" class="btn btn-primary" (click)="rename()" [disabled]="!newSku || newSku.trim() === sku || skuChecking || skuAvailable !== true || disabled" ui-modal-footer>
		Rename<i class="wq wq-arrow-right ml-1"></i>
	</button>
	<button *ngIf="step === 'merge'" type="button" class="btn btn-primary" (click)="merge()" [disabled]="!selectedTarget || disabled" ui-modal-footer>
		Merge<i class="wq wq-arrow-right ml-1"></i>
	</button>
	<button *ngIf="step === 'separate'" type="button" class="btn btn-primary" (click)="separate()" [disabled]="!newSku || newSku.trim() === sku || skuChecking || skuAvailable !== true || !separationInfo || disabled" ui-modal-footer>
		Separate<i class="wq wq-arrow-right ml-1"></i>
	</button>

</ui-modal>

